module.exports = __webpack_public_path__ + "static/img/app-slide-show2.19d5a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-tb-wgm/images/app-slide-show2.png
// module id = HJwO
// module chunks = 44